import React from 'react';
import Completion from '../assets/images/Completion_Check.svg';

export default () => {
  return <img src={Completion} alt="" />;
};
